// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__pZHDM","calendarButtons":"ClockData_calendarButtons__1Qpz6"};